<template>
    <div class="component-butto-panel">
       <div class="panel-button">
         <h3>按钮属性</h3>
         <el-form :model="button" :inline="true" class="form-button" :rules="rules" ref="ruleForm" label-width="80px" label-position="left">
           <el-form-item label="按钮名称" prop="name">
             <el-input v-model="button.name"></el-input>
           </el-form-item>
           <el-form-item label="按钮功能">
             <el-select v-model="button.type" placeholder="请选择" v-if="['create', 'import', 'export', 'custom-top','filter-item-calculation'].some(n=>n===button.type)">
               <el-option label="新建" value="create"></el-option>
               <el-option label="导入" value="import"></el-option>
               <el-option label="导出" value="export"></el-option>
               <el-option label="自定义" value="custom-top"></el-option>
               <el-option label="筛选项计算" value="filter-item-calculation"></el-option>
             </el-select>
             <el-select v-model="button.type" placeholder="请选择" v-else @change="changeButtonType">
               <el-option label="查看" value="look"></el-option>
               <el-option label="修改" value="update"></el-option>
               <el-option label="删除" value="delete"></el-option>
               <el-option label="打印" value="print-column"></el-option>
               <el-option label="电子合同" value="online-contract" v-if="contractEnable" key="contract-button"></el-option>
               <el-option label="自定义" value="custom-bottom"></el-option>
              </el-select>
           </el-form-item>
           <el-form-item label="导入类型" v-if="button.type==='import'">
             <el-select v-model="button.importType" >
               <el-option label="新增" value="increase"></el-option>
               <el-option label="新增或更新" value="increaseOrUpdate"></el-option>
             </el-select>
           </el-form-item>
           <el-form-item v-if="button.type==='print-column'" label="选择模板" :error="errorMessage" prop="templateName" key="templateName">
             <el-select v-model="button.templateName" placeholder="请选择" filterable>
               <el-option
                 v-for="item in templates"
                 :key="item.id"
                 :label="item.templateName"
                 :value="item.id">
               </el-option>
             </el-select>
           </el-form-item>
           <template v-if="button.type==='look' || button.type==='update' || button.type==='create'">
             <el-form-item label="功能指向" class="group" key="group">
                <el-select v-model="button.targetType" placeholder="请选择" @change="changeTargetType">
                   <el-option label="表单" value="form"></el-option>
                   <el-option label="流程" value="flow"></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label=" " class="group" prop="targetId" key="targetId">
               <public-combobox v-model="button.targetId" :options="getTargetData"></public-combobox>
             </el-form-item>
           </template>
           <el-form-item v-if="button.type==='import'" label="导入列" key="importColumns">
             <el-select v-model="importColumns" filterable multiple collapse-tags>
               <el-option
                 class="import-columns-select"
                 v-for="item in getAllArchiveColumns"
                 :title="item.name"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id">
               </el-option>
             </el-select>
           </el-form-item>
           <!-- 用v-show会报错 -->
           <el-form-item v-if="button.type==='export'" label="导出列" key="exportColumns">
             <el-select v-model="exportColumn" filterable multiple collapse-tags>
               <el-option
                 v-for="item in getColumns"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id">
               </el-option>
             </el-select>
           </el-form-item>
           <!--筛选项计算-->
           <template v-if="button.type==='filter-item-calculation'">
             <el-form-item v-for="item in reportService.report.filters" :label="item.name" :key="item.id">
               <div class="disable-condition" v-html="seniorConvert(button.filterItems[item.id])" @click="getButtonCalculation(item.id)"></div>
             </el-form-item>
           </template>
           <!-- 电子合同-->
           <template v-if="button.type === 'online-contract'">
             <el-form-item label="选择模板" prop="setting.templateId" key="templateId">
               <el-select v-model="button.setting.templateId" placeholder="请选择">
                 <el-option
                   v-for="item in templates"
                   :key="item.id"
                   :label="item.templateName"
                   :value="item.id">
                 </el-option>
               </el-select>
             </el-form-item>
             <el-form-item label="电子公章" prop="setting.sealId" key="sealId">
               <el-select v-model="button.setting.sealId" placeholder="请选择">
                 <el-option
                   v-for="item in seals"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </el-form-item>
             <el-form-item label="签署类型" prop="setting.signType" key="signType">
               <el-select v-model="button.setting.signType" placeholder="请选择">
                 <el-option label="公司" value="COMPANY"></el-option>
                 <el-option label="个人" value="PERSONAL"></el-option>
               </el-select>
             </el-form-item>
             <el-form-item v-if="button.setting.signType === 'COMPANY'" label="公司名称" prop="setting.companyColumn" key="companyColumn">
               <el-select v-model="button.setting.companyColumn" placeholder="请选择">
                 <el-option
                   v-for="item in EContractColumn"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </el-form-item>
             <el-form-item :label="button.setting.signType !== 'PERSONAL'? '经办人':'姓名'" prop="setting.nameColumn" key="nameColumn">
               <el-select v-model="button.setting.nameColumn" placeholder="请选择">
                 <el-option
                   v-for="item in EContractColumn"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </el-form-item>
             <el-form-item label="联系方式" prop="setting.contactColumn" key="contactColumn">
               <el-select v-model="button.setting.contactColumn" placeholder="请选择">
                 <el-option
                   v-for="item in EContractColumn"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </el-form-item>
           </template>
           <el-form-item label="禁用条件" v-if="button.type!=='filter-item-calculation'" key="disable-condition">
             <div class="disable-condition" v-html="seniorConvert(button.expressionText)" @click="getButtonExpression"></div>
           </el-form-item>
           <el-form-item class="tipsEnable" key="tipsEnable" label="操作提醒" v-if="button.type!=='import'&&button.type!=='export'&&button.type!=='print-column'&&button.type!=='online-contract'&&button.type!=='filter-item-calculation'">
             <el-switch v-model="button.tipsEnable"></el-switch>
           </el-form-item>
           <el-form-item class="tip" key="tip" v-if="button.tipsEnable&&button.type!=='import'&&button.type!=='export'&&button.type!=='print-column'&&button.type!=='online-contract'">
            <el-input v-model="button.tip" maxlength="15"></el-input>
           </el-form-item>
           <el-form-item v-if="['create', 'import', 'export', 'custom-top', 'filter-item-calculation'].includes(button.type)" label="显示方式" key="showType">
             <el-select v-model="button.showFlag" placeholder="请选择">
               <el-option label="折叠" value="fold"></el-option>
               <el-option label="展开" value="open"></el-option>
             </el-select>
           </el-form-item>
         </el-form>
         <!--<fieldset v-if="button.type!=='create' && button.type!=='import' && button.type!=='export'">
           <legend>限制状态</legend>
           <div v-for="(condition, index) in restrictiveCondition" :key="index">
             <el-row>
               <el-col :span="24">
                 <el-select v-model="condition.columnId" placeholder="请选择数据列">
                   <el-option
                     v-for="item in getColumns"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
                   </el-option>
                 </el-select>
               </el-col>
             </el-row>
             <el-row>
               <el-col :span="12">
                 <el-select v-model="condition.condition" placeholder="请选择">
                   <el-option label="等于" value="="></el-option>
                   <el-option label="不等于" value="!="></el-option>
                   <el-option label="大于" value=">"></el-option>
                   <el-option label="大于等于" value=">="></el-option>
                   <el-option label="小于" value="<"></el-option>
                   <el-option label="小于等于" value="<="></el-option>
                 </el-select>
               </el-col>
               <el-col :span="12">
                 <el-input v-model="condition.content"></el-input>
               </el-col>
             </el-row>
           </div>
         </fieldset>-->
         <el-row type="flex" justify="center" class="buttons">
            <el-button type="primary" @click="saveAttr">保存</el-button>
            <el-button type="primary" plain @click="closeAttr">关闭</el-button>
          </el-row>
      </div>
    </div>
</template>

<script>
import publicCombobox from '@/components/public/public-combobox.vue'
export default {
  name: 'ButtonPanel',
  inject: ['reportService'],
  props: {
    contractEnable: Boolean
  },
  components: {publicCombobox},
  data () {
    let id = this.reportService.options.leftPanel.id
    const button = this.$_.cloneDeep(this.reportService.report.buttons.find(m => m.id === id))
    if (!button.targetId) {
      button.targetType = this.reportService.options.processTargetId ? 'flow' : 'form'
      button.targetId = button.targetType === 'form' ? this.reportService.options.formTargetId : this.reportService.options.processTargetId
    }
    // 处理没有setting选项的
    button.setting = typeof button.setting === 'string' ? JSON.parse(button.setting) : {}
    button.tip = button.tip || '您确定执行此操作吗?'
    button.templateName = button.targetId
    //  53期新增显示方式、筛选项列表
    button.showFlag = button.showFlag || 'fold'
    button.filterItems = typeof button.filterItems === 'string' ? JSON.parse(button.filterItems) : button.filterItems
    return {
      button: button,
      exportColumn: [],
      EContractColumn: [],
      restrictiveCondition: [],
      importColumns: [],
      rules: {
        name: [
          { required: true, message: '请输入按钮名称', trigger: 'blur' },
          { min: 1, max: 6, message: '长度在 1 到 6 个字符', trigger: 'blur' }
        ],
        targetId: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        templateName: [
          { required: true, message: '请选择模板', trigger: 'change' }
        ],
        'setting.templateId': [
          { required: true, message: '请选择模板', trigger: 'blur' }
        ],
        'setting.sealId': [
          { required: true, message: '请选择电子公章', trigger: 'blur' }
        ],
        'setting.signType': [
          { required: true, message: '请选择签署类型', trigger: 'blur' }
        ],
        'setting.nameColumn': [
          { required: true, message: '请选择经办人', trigger: 'blur' }
        ],
        'setting.contactColumn': [
          { required: true, message: '请选择联系方式', trigger: 'blur' }
        ],
        'setting.companyColumn': [
          { required: true, message: '请选择公司名称', trigger: 'blur' }
        ]
      },
      templates: [],
      seals: [],
      errorMessage: ''
    }
  },
  watch: {
    'button.type' (val) {
      switch (val) {
        case 'create':
          this.button.name = '新建'
          break
        case 'import':
          this.button.name = '导入'
          break
        case 'export':
          this.button.name = '导出'
          break
        case 'look':
          this.button.name = '查看'
          break
        case 'update':
          this.button.name = '修改'
          break
        case 'delete':
          this.button.name = '删除'
          break
        case 'custom-top':
          this.button.name = '自定义'
          break
        case 'custom-bottom':
          this.button.name = '自定义'
          break
        case 'print-column':
          this.button.name = '打印'
          break
        case 'online-contract':
          this.button.name = '电子合同'
          break
      }
    },
    'button.templateName' (val) {
      if (val) this.errorMessage = ''
    }
  },
  created () {
    if (this.button.type === 'delete') {
      this.button.tipsEnable = true
    } else if (this.button.type === 'online-contract') {
      // 获取电子合同按钮的公章列表
      this.getSeals()
    }
    if (this.button.type === 'import' && !this.button.importType) {
      this.button.importType = 'increase'
    }
    this.initExportColumn()
    this.initImportColumn()
    this.initEContractColumn()
    this.getTemplates()
    // this.initButtonRestrictiveCondition()
  },
  methods: {
    changeButtonType (val) {
      if (val === 'delete') {
        this.button.tipsEnable = true
      } else if (val === 'print-column') {
        this.button.templateName = ''
      } else if (val === 'online-contract') {
        // 获取电子合同按钮的公章列表
        this.getSeals()
      } else if (val !== 'online-contract' && this.button.setting.templateId === this.button.targetId) {
        this.button.targetId = this.button.targetType === 'form' ? this.reportService.options.formTargetId : this.reportService.options.processTargetId
      }
    },
    initExportColumn () {
      this.reportService.report.columns.forEach(m => {
        if (m.exportable) {
          this.exportColumn.push(m.id)
        }
      })
    },
    initImportColumn () {
      // 根据字段是否存在来判断是新建的按钮还是历史数据
      if (!('importColumns' in this.button.setting)) {
        // 如果不存在, 默认选中全部
        this.button.setting.importColumns = []
        this.getAllArchiveColumns.forEach(col => {
          this.importColumns.push(col.id)
        })
      } else {
        this.importColumns = this.button.setting.importColumns
      }
    },
    initEContractColumn () {
      this.EContractColumn = this.reportService.report.columns.map(e => {
        return {name: e.name, id: e.id}
      })
    },
    changeTargetType (value) {
      this.button.targetId = value === 'form' ? this.reportService.options.formTargetId : this.reportService.options.processTargetId
    },
    initButtonRestrictiveCondition () {
      // 初始化按钮的限制规则
      if (this.button.restrictiveCondition) {
        this.restrictiveCondition = JSON.parse(this.button.restrictiveCondition)
      } else {
        this.addCondition()
      }
    },
    addCondition () {
      this.restrictiveCondition.push({'columnId': '', 'condition': '=', 'content': ''})
    },
    saveAttr () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.button.type === 'print-column' && this.button.templateName === '') {
            this.errorMessage = '请选择模板'
            return false
          }
          // this.handleConditon()
          if (this.button.tipsEnable === false) {
            this.button.tip = ''
          }
          // 模板id与报表/流程id公用
          if (this.button.type === 'print-column') {
            this.button.targetId = this.button.templateName
          }
          if (this.button.type === 'import') {
            this.button.setting.importColumns = this.importColumns
          }
          // 电子合同属性使用json存储
          if (this.button.type === 'online-contract') {
            this.button.targetId = this.button.setting.templateId
          }
          // setting值转json格式存储
          this.button.setting = JSON.stringify(this.button.setting)
          this.$nextTick(() => {
            this.reportService.createOrUpdate(this.button)
            this.reportService.updateExportColumn(this.exportColumn)
            this.closeAttr()
          })
        } else {
          return false
        }
      })
    },
    handleConditon () {
      let condition = []
      this.restrictiveCondition.forEach(m => {
        if (m.columnId && m.condition && m.content) {
          condition.push(m)
        }
      })
      if (condition.length > 0) {
        this.button.restrictiveCondition = JSON.stringify(condition)
      }
    },
    closeAttr () {
      this.reportService.closePanel()
    },
    getButtonExpression () {
      this.$Popup.calculation({
        parameter: {
          title: '表达式设计',
          expression: this.button.expressionText || '',
          dataSource: this.reportService.getReportJoinTables(),
          functionType: ['simple', 'math', 'text', 'date', 'concat', 'logic', 'system'],
          calculationType: 'sql'
        },
        width: '1000px'
      }).then((data) => {
        if (data.action === 'confirm') {
          this.$set(this.button, 'expressionText', data.value)
        }
      })
    },
    //  筛选项计算
    getButtonCalculation (id) {
      this.$Popup.calculation({
        parameter: {
          title: '表达式设计',
          expression: this.button.filterItems[id] || '',
          dataSource: this.reportService.getReportJoinTables(),
          functionType: ['simple', 'math', 'text', 'date', 'concat', 'logic', 'system'],
          calculationType: 'sql'
        },
        width: '1000px'
      }).then((data) => {
        if (data.action === 'confirm') {
          this.$set(this.button.filterItems, id, data.value)
        }
      })
    },
    seniorConvert (expression) {
      // 转换,
      if (expression) {
        expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map(el => {
          let codeAttr = el.replace(/[${}]/g, '').split(',')
          let code = `&nbsp;<span contenteditable='false' dataId=${codeAttr[0]} name=${codeAttr[1]} type=${codeAttr[2]}>${codeAttr[1]}</span>&nbsp;`
          expression = expression.replace(el, code)
        })
        return expression
      }
    },
    getTemplates () {
      let params = {
        index: 1,
        size: -1,
        filters: {
          templateName: '',
          paramType: '报表',
          definitionId: this.reportService.report.id
        }
      }
      this.$axios.get('/system-api/printTemplate', { params }).then(({data}) => { this.templates = data.items || [] })
    },
    // 获取电子合同公章列表
    getSeals () {
      this.$axios.get('/system-api/contract/seal/list')
        .then((res) => {
          this.seals = res.data && res.data.items
        })
    }
  },
  computed: {
    getTargetData () {
      if (this.button.targetType === 'form') {
        return this.reportService.options.form
      } else {
        return this.reportService.options.process
      }
    },
    getAllArchiveColumns () {
      // 审计字段 (用名区分,不严谨...后端也这么区分的; todo: 后续可以考虑加一个字段来区分)
      let auditColumns = ['标识', '创建人', '创建人姓名', '实例id', '创建时间', '最后创建时间', '最近修改时间', '记录状态', '删除标记', '删除标志', '最后修改人', '最后修改人姓名']
      return this.reportService.options.allAchivedColumns.filter(col => {
        return !auditColumns.includes(col.name)
      })
    },
    getColumns () {
      return this.reportService.report.columns
    }
  }
}
</script>

<style lang="scss">
.component-butto-panel {
  height: 100%;
  .panel-button {
    height: calc(100% - 40px);
    h3 {
      padding: 10px 15px;
      background-color: #ecf5ff;
      font-weight: normal;
      text-align: center;
      color: #55acf1;
      border-bottom: 2px solid #54abf1;
    }
    .form-button {
      padding: 14px 0 0 12px;
      .el-form-item {
        margin-bottom: 12px;
        .el-form-item__label{
          padding-right: 6px;
        }
        &.target-id {
          margin-left: 78px;
        }
        .el-form-item__content {
          width: 139px;
        }
        &.tipsEnable {
         .el-form-item__content {
           text-align: right;
         }
        }
        &.tip {
          .el-input__inner{
            width: 210px;
            margin-left: 10px;
          }
        }
        .el-select__tags{
          flex-wrap: nowrap;
          >span{
            display: flex;
            >span{
              display: flex;
              max-width: 78px;
              padding-right: 0;
              >span{
                flex: 0 1 70%;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            >span:nth-of-type(2){
              padding-left: 0;
              margin-left: 0;
              >span{
                flex: auto;
              }
            }
          }
          >.el-select__input.is-mini{
            display: none;
          }
        }
      }
      .el-form-item:not(.is-required){
        .el-form-item__label{
          padding-left: 10px;
        }
      }
    }
    .buttons {
      height: 10%;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      background: #fff;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      button{
        width: 72px;
      }
    }
    fieldset {
      margin-left: 10px;
      margin-right: 10px;
      padding-left: 12px;
      padding-right: 0px;
      border: 1px solid #c2c3c4;
      border-radius: 4px;
    }

    .disable-condition {
      border: 1px solid #c0c4cc;
      background-color: rgb(235, 235, 228);
      -ms-text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width:139px;
      height:29px;
      line-height: 29px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
  .el-select-dropdown{
    .import-columns-select{
      span{
        display: inline-block;
        width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/button-panel.vue